import { SessionSiteSelectors } from '~selectors/SessionInfoSelectors';
import { getAppStore } from '~src/app/AppStore';
import { AppState } from '~src/app/state/AppState';
import { createFlowSubscription } from '~src/flow/actions/CreateFlowSubscriptionReduxAction';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { isSingleUnpublishedFlowDraft } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';
import { ICreateSubscriptionAction } from '../../ts/ServerApi/types/actionNames';

export const CreateFlowSubscriptionEntityAction: IEntityAction<IContentInfo<'flow'>, ICreateSubscriptionAction> = {
  name: EntityActionNames.CreateFlowSubscription,
  translateName: Messages.flowSubscriptionsReduxActionName,
  isVisible: (_, state: AppState) => state ? SessionSiteSelectors.isFlowOutputSubscriptionsEnabled(state) : SessionSiteSelectors.isFlowOutputSubscriptionsEnabled(getAppStore().getState()),
  isClickable: (availableActions: ICreateSubscriptionAction, targetItems) => !!availableActions && availableActions.createSubscription &&
    !isSingleUnpublishedFlowDraft(targetItems),
  createReduxAction: (targetItems: IContentInfo[]) => createFlowSubscription(targetItems[0])
};
